import ResourcesService from '@/services/resources.service.js'

const state = {
    resources : null,
    TestaFattura: null,
    ChkSeasonalOrders: null
}

const getters =  {
    getResources: (state) => (lang) => {
        
        return  state.resources[lang];
    },
    getTestaFattura: (state) =>{
        let v = localStorage.getItem(state.project_name + "TestaFattura");
        if(state.TestaFattura == null || state.TestaFattura == 'undefined'){
            return JSON.parse(v);
        }else{
            return state.TestaFattura
        }
    },
    getChkSeasonalOrders: (state) => {
        return state.ChkSeasonalOrders ?? JSON.parse(localStorage.getItem("crsSeasonal"));
    }
}

const mutations = {
    setResources: (state, resources)  => {
        state.resources = resources;
    },
    setTestaFattura: (state, value) =>{
        localStorage.setItem(state.project_name + "TestaFattura", JSON.stringify(value));
        state.TestaFattura = value;
    },
    setChkSeasonalOrders: (state, data) =>{
        state.ChkSeasonalOrders = data;
        localStorage.setItem('crsSeasonal', JSON.stringify(state.ChkSeasonalOrders));
    }
}

const actions = {
    getResourcesFromApi: ({commit}, data) => {       
        return ResourcesService.getRisorse(data.token, data.codShop).then(
            (data) => {                      
                if(data){
                    commit('setResources', data);
                    return true;
                }
                else{
                    return false;
                }                            
            }          
        ).catch(
            error => {return false}
        );
    }
}




export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}